export const DOMAIN_COUNTRY_MAP: { [key: string]: string } = {
    // getDomainCountry() builds `https://${host}`, so only the https spellings are ever matched —
    // the http ones below are kept for the places that read a configured DOMAIN instead.
    // Local dev answers as the UAE domain, the one with holiday content.
    'https://localhost:3000': 'AE',
    'https://localhost:3001': 'AE',
    'http://localhost:3001': 'FSA',
    'http://localhost:3000': 'FSA',
    'https://me.cleartrip.ae': 'AE',
    'https://www.cleartrip.ae': 'AE',

    'https://om.cleartrip.com': 'OM',
    'https://om.cleartrip.sa': 'OM',
    'https://www.cleartrip.om': 'OM',
    'https://qa2om.cleartrip.com': 'OM',

    'https://qar.cleartrip.sa': 'QA',
    'https://www.cleartrip.qa': 'QA',
    'https://qa.cleartrip.com': 'QA',
    'https://qa2qa.cleartrip.com': 'QA',

    'https://bh.cleartrip.sa': 'BH',
    'https://www.cleartrip.bh': 'BH',
    'https://bh.cleartrip.com': 'BH',
    'https://qa2bh.cleartrip.com': 'BH',

    'https://kw.cleartrip.com': 'KW',
    'https://qa2kw.cleartrip.com': 'KW',
    'https://kw.cleartrip.sa': 'KW',
    'https://www.cleartrip.com.kw': 'KW',
    'https://www.cleartrip.kw': 'KW',

    'https://www.cleartrip.sa': 'SA',
    'https://qa2.cleartrip.sa': 'SA',
    'https://me.cleartrip.sa': 'SA',
    'https://www.flyin.com': 'FSA',
    'https://heya.flyin.com': 'FSA',
    'https://me-heya.flyin.com': 'FSA',
    'https://eg.flyin.com': 'FEG',
    'https://ae.flyin.com': 'FAE',

    'https://me.flyin.com': 'FSA',
    'https://meeg.flyin.com': 'FEG',
    'https://meae.flyin.com': 'FAE'
}
export const PAGE_COUNTRY_MAP: { [key: string]: string } = {
    'http://localhost:3001': 'ae',
    'http://localhost:3000': 'ae',
    'https://me.cleartrip.ae': 'ae',
    'https://www.cleartrip.ae': 'ae',

    'https://om.cleartrip.com': 'om',
    'https://om.cleartrip.sa': 'om',
    'https://www.cleartrip.om': 'om',
    'https://qa2om.cleartrip.com': 'om',

    'https://qar.cleartrip.sa': 'qa',
    'https://www.cleartrip.qa': 'qa',
    'https://qa.cleartrip.com': 'qa',
    'https://qa2qa.cleartrip.com': 'qa',

    'https://bh.cleartrip.sa': 'bh',
    'https://www.cleartrip.bh': 'bh',
    'https://bh.cleartrip.com': 'bh',
    'https://qa2bh.cleartrip.com': 'bh',

    'https://kw.cleartrip.com': 'kw',
    'https://qa2kw.cleartrip.com': 'kw',
    'https://kw.cleartrip.sa': 'kw',
    'https://www.cleartrip.com.kw': 'kw',
    'https://www.cleartrip.kw': 'kw',

    'https://www.cleartrip.sa': 'sa',
    'https://qa2.cleartrip.sa': 'sa',
    'https://me.cleartrip.sa': 'sa',
    'https://www.flyin.com': 'global',
    'https://heya.flyin.com': 'global',
    'https://me-heya.flyin.com': 'global',
    'https://eg.flyin.com': 'eg',
    'https://ae.flyin.com': 'ae',

    'https://me.flyin.com': 'global',
    'https://meeg.flyin.com': 'eg',
    'https://meae.flyin.com': 'ae'
}

export const DOMAIN = typeof window !== 'undefined' ? window.location.origin : 'https://www.cleartrip.ae'

export const domainCountry = DOMAIN_COUNTRY_MAP[DOMAIN as keyof typeof DOMAIN_COUNTRY_MAP] || 'AE'

export const LOGIN_PROMO_CONFIG: Record<string, { discount: string; code: string }> = {
    FSA: { discount: 'SAR 50 OFF*', code: 'HALA50' },
    FEG: { discount: 'EGP 400 OFF*', code: 'AHLANEGY' }
}

export const DEFAULT_LOGIN_PROMO = { discount: 'up to 10% OFF*', code: 'AHLANUAE' }

export const getLoginPromoConfig = () => LOGIN_PROMO_CONFIG[domainCountry] || DEFAULT_LOGIN_PROMO
